//Colors
export const YELLOW = "#FEAA01";
export const ERROR_RED = "#D85829";
export const LIGHT_GREEN = "#43e625";
export const PARROT_GREEN = "#7CCA1A";
export const LIGHT_GREY = "#D4D4D4";
